import { getAccessToken } from 'core/auth/accessTokenStorage';

export const AUTH_UNAUTHORIZED_EVENT = 'auth:unauthorized';

export const dispatchUnauthorized = () => {
  if (getAccessToken()) {
    window.dispatchEvent(new CustomEvent(AUTH_UNAUTHORIZED_EVENT));
  }
};
